.container {
  display: flex;
  flex-direction: column;
  padding-top: var(--tuna-spacing-2);
}

.subtitle {
  padding-bottom: var(--tuna-spacing-2);
}

.tuningRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.sliderBox {
  padding: var(--tuna-spacing-1);
}
